<div id="product-color-selector">
    @if ((showColorBullets$ | async) === true) {
        <div class="row {{ classConfig.wrap }}">
            @if (showColorName) {
                <div class="col-xs-12">
                    <product-color-info
                        [selectedColor]="selectedColor"
                        [textPosition]="textPosition"
                        [isHexadecimalColors]="isHexadecimalColors"
                        [isCustomizationColor]="isCustomizationColor"
                        [displayReference]="displayReference"
                    ></product-color-info>
                </div>
            }

            <div class="col-xs-12">
                <!-- UX NEW PDP BOTTOM SHEET ngClass -->
                <div
                    class="is-flex"
                    [ngClass]="{
                        'list-clear content-center flex-wrap': !designByGroup,
                        'border-clean-r bs-group-colors': designByGroup
                    }"
                >
                    @for (color of colorsView; track trackByIndex) {
                        <button
                            class="btn-tertiary btn--color {{ classConfig.button }}"
                            [class.mb-8]="!designByGroup"
                            [class.is-active]="color?.id === selectedColor?.id"
                            title="{{ (color?.name | translate) + ', Ref. ' + displayReference }}"
                            (click)="changeColor(color)"
                            aria-label="{{ color?.name | translate }}"
                            [attr.aria-selected]="color?.id === selectedColor?.id ? 'true' : 'false'"
                            role="option"
                        >
                            @if (isHexadecimalColors) {
                                <div class="color-selector">
                                    <div class="color-selector-in {{ classConfig.button }}" [style.background-color]="color.hexValue"></div>
                                </div>
                            } @else {
                                <div class="is-flex color-selector title-l">
                                    <img loading="lazy" src="{{ getProductColorUrl(color) }}" alt="{{ color?.name }}" />
                                </div>
                            }
                        </button>
                    }
                    <!-- New PDP -->
                    @if (designByGroup && moreColors) {
                        <div class="is-flex color-selector title-l color-more" (click)="goToProductDetails()">
                            {{ moreColors }}
                        </div>
                    }
                </div>

                @if (!designByGroup && moreColors) {
                    <div
                        class="ml-16 color-selector"
                        [ngStyle]="{ color: templateConfiguration?.styles && templateConfiguration?.styles['colorSelector'] }"
                        (click)="goToProductDetails()"
                    >
                        {{ moreColors }}
                    </div>
                }
            </div>
        </div>

        @if ((showColorBullets$ | async) === false) {
            <div>
                <span class="mobile-color" [ngStyle]="{ color: templateConfiguration?.styles && templateConfiguration?.styles['colorSelector'] }"
                    >{{ totalColors }} {{ 'dev.product.colors' | translate }}</span
                >
            </div>
        }
    }
</div>

<ng-template #moreColorsLink>
    @if (moreColors) {
        <div
            class="ml-16 color-selector"
            [ngStyle]="{ color: templateConfiguration?.styles && templateConfiguration?.styles['colorSelector'] }"
            (click)="goToProductDetails()"
        >
            {{ moreColors }}
        </div>
    }
</ng-template>
